import { RESET_STATE } from 'store/global/actions';

import { MANAGED_USERS_ACTIONS } from '../actions';

const initialState = [];

const managedUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MANAGED_USERS_ACTIONS.GET_USERS:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default managedUsersReducer;
